import React from 'react'
import { defineMessages } from 'react-intl'

import FAQItem from 'components/FaqItem'
import PageSubTitle from 'components/Page/Page.SubTitle.js'
import { View } from 'components/View.js'
import markdownToHtmlStringUtil from 'utils/string/markdown-to-html'
import useIntl from 'modules/component/utils/hooks/useIntl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'

const fitnessToolsMessage = defineMessages({
  title: {
    id: 'FitnessToolsFAQItems.title',
    defaultMessage: 'Fitness Tools 🛠️'
  },
  whatAreFitnessToolsQuestion: {
    id: 'FitnessToolsFAQItems.whatAreFitnessToolsQuestion',
    defaultMessage: 'What are Fitness Tools?'
  },
  whatAreFitnessToolsAnswer: {
    id: 'FitnessToolsFAQItems.whatAreFitnessToolsAnswer',
    defaultMessage:
      'Fitness Tools are AI-powered features that help you train smarter and reach your goals. They include tools like form checking, workout generation, and more.'
  },
  checkExerciseFormQuestion: {
    id: 'FitnessToolsFAQItems.checkExerciseFormQuestion',
    defaultMessage: 'How does the exercise form checker work?'
  },
  checkExerciseFormAnswer: {
    id: 'FitnessToolsFAQItems.checkExerciseFormAnswer',
    defaultMessage:
      'Upload a video of your exercise and our AI will analyze your form, posture, and technique. You’ll get instant feedback on what you’re doing right and what needs improvement.'
  },
  whichExercisesFormCheckQuestion: {
    id: 'FitnessToolsFAQItems.whichExercisesFormCheckQuestion',
    defaultMessage: 'Which exercises can I check my form for?'
  },
  whichExercisesFormCheckAnswer: {
    id: 'FitnessToolsFAQItems.whichExercisesFormCheckAnswer',
    defaultMessage:
      'The AI form checker supports over 1800+ exercises including squats, deadlifts, bench press, pull-ups, and many more. We’re continuously adding support for more exercises.'
  },
  formCheckAccuracyQuestion: {
    id: 'FitnessToolsFAQItems.formCheckAccuracyQuestion',
    defaultMessage: 'How accurate is the AI form checker?'
  },
  formCheckAccuracyAnswer: {
    id: 'FitnessToolsFAQItems.formCheckAccuracyAnswer',
    defaultMessage:
      'Our AI is trained on thousands of exercise videos and provides accurate feedback on your form. For best results, make sure your video clearly shows your full body and the exercise movement.'
  },
  howToAccessToolsQuestion: {
    id: 'FitnessToolsFAQItems.howToAccessToolsQuestion',
    defaultMessage: 'How do I access Fitness Tools?'
  },
  howToAccessToolsAnswer: {
    id: 'FitnessToolsFAQItems.howToAccessToolsAnswer',
    defaultMessage:
      'You can access Fitness Tools from the [Tools page](/tools "Tools page"). Some tools are available for free, while others require a Premium subscription.'
  }
})

const FAQ_ITEMS = [
  {
    title: fitnessToolsMessage.title,
    items: [
      {
        question: fitnessToolsMessage.whatAreFitnessToolsQuestion,
        answer: fitnessToolsMessage.whatAreFitnessToolsAnswer
      },
      {
        question: fitnessToolsMessage.checkExerciseFormQuestion,
        answer: fitnessToolsMessage.checkExerciseFormAnswer
      },
      {
        question: fitnessToolsMessage.whichExercisesFormCheckQuestion,
        answer: fitnessToolsMessage.whichExercisesFormCheckAnswer
      },
      {
        question: fitnessToolsMessage.formCheckAccuracyQuestion,
        answer: fitnessToolsMessage.formCheckAccuracyAnswer
      },
      {
        question: fitnessToolsMessage.howToAccessToolsQuestion,
        answer: fitnessToolsMessage.howToAccessToolsAnswer
      }
    ]
  }
]

export default function FitnessToolsFAQItems () {
  const intl = useIntl()

  return (
    <View className='fitness-tools-faq-items' style={{ textAlign: 'left' }}>
      {FAQ_ITEMS.map((section) => {
        const {
          title,
          items
        } = section
        const titleStr = formatMessageIntlUtil(intl, title)

        return (
          <View key={titleStr}>
            <PageSubTitle>{titleStr}</PageSubTitle>
            {items.map((item) => {
              const {
                question,
                answer
              } = item
              const questionStr = formatMessageIntlUtil(intl, question)
              const answerStr = formatMessageIntlUtil(intl, answer)

              return (
                <FAQItem
                  key={questionStr}
                  question={questionStr}
                  answer={
                    <View>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: markdownToHtmlStringUtil(answerStr)
                        }}
                      />
                    </View>
                  }
                />
              )
            })}
          </View>
        )
      })}
    </View>
  )
}
